/**
 * ViewsShow directive
 * used with viewsService to show/hide by style element depending on Yii views
 *
 * example : [viewsShow]="{pageName: 'search', path: 'fields.booking.references'}"
 * @param {event} focus
 */


import { AfterViewInit, Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { ViewsService } from "./views.service";

@Directive({
    selector: '[viewsShow]'
})
export class ViewsShowDirective implements AfterViewInit {
    @Input('viewsShow')
    public path: string ;

    @Input('viewsPage')
    public pageName: string;

    public canShow: boolean;

    constructor(
        private readonly el: ElementRef,
        private readonly renderer: Renderer2,
        private readonly views: ViewsService) {
    }


    public ngAfterViewInit(): void {
        //for debug, add path in classes
        this.renderer.addClass(this.el.nativeElement, this.path);

        this.views.view.subscribe((view) => {

            const showMe = this.views.canShow(view, this.pageName, this.path);
            if (!showMe) {
                this.renderer.setStyle(this.el.nativeElement, "display", "none");
            }else{
                this.renderer.removeStyle(this.el.nativeElement, "display");
            }
        });

    }


}
